export default "__VITE_ASSET__BpmSyRcf__"